
import Rewards from "../employee-recognition/Rewards";

export { Page }

function Page() {
  return <Rewards />;
}
